import CustomButton from 'components/buttons/CustomButton'
import CheckboxField from 'components/checkbox/CheckboxField'
import Progress from 'components/progress/Progress'
import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import I18n from '../../resources/i18n/I18n'

const EventConsultActionBarModal = ({
  showModal,
  toggleExportModal,
  loading,
  selectedEvents,
  tooMuchEvents,
  exportType,
  setExportAll,
  exportAll,
  exportPourcentage,
  setExportType,
  setExportPourcentage,
  filters,
  setExportId,
  socketRef,
}) => {
  const changeExportType = (type) => {
    if (exportPourcentage) {
      return
    }

    setExportType(type)
    if (type !== 'csv' && exportAll) {
      setExportAll(false)
    }
  }

  /**
   * Permet de générer un export PDF ou CSV
   */
  const generateExport = async () => {
    socketRef.current.emit(
      'exportEvents',
      {
        query: {
          eventIdList: exportType === 'csv' && exportAll ? undefined : selectedEvents.map((event) => event.id),
          ...filters,
        },
        exportType,
      },
      (exportId) => {
        setExportId(exportId)
        setExportPourcentage(2)
      },
    )
  }

  return (
    <Modal className="modal" show={showModal && !tooMuchEvents} onHide={toggleExportModal}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('ExportEvent')}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex justify-content-center align-items-center">
        {loading ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex justify-content-center align-items-center">
              {selectedEvents.length > 0 && (
                <span onClick={() => changeExportType('pdf')} className={`icon-pdf icon-container p-1 ${exportType === 'pdf' ? 'border' : ''}`} />
              )}

              <div className="d-flex action-bar">
                <span
                  className={`icon-xsl icon-container p-1 ${exportType === 'xlsx' ? 'border' : ''}`}
                  onClick={() => changeExportType('xlsx')}
                ></span>
                <span
                  className={`icon-csv icon-container p-1 ${exportType === 'csv' ? 'border' : ''}`}
                  onClick={() => changeExportType('csv')}
                ></span>
              </div>
            </div>
            <CheckboxField
              name="selectAll"
              className={`${exportType === 'csv' && selectedEvents.length ? 'mt-4 mb-3' : 'invisible'}`}
              value={exportAll}
              onChange={() => setExportAll(!exportAll)}
              label={I18n.t('ExportConfirmAll')}
            />
            <CustomButton
              onClick={generateExport}
              small
              primary
              title={I18n.t(selectedEvents.length && !exportAll ? 'ExportConfirmSelected' : 'ExportConfirmAll')}
              disabled={exportPourcentage}
            />
            {exportPourcentage > 0 && (
              <span className="mt-2 mb-2 text-center">{I18n.t(exportPourcentage > 85 ? 'ExportDownloading' : 'ExportProgress')}</span>
            )}
            {exportPourcentage > 0 && <Progress value={exportPourcentage} />}
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default EventConsultActionBarModal
